"use strict";

define('layout/main.layout',['marionette', '../templates'], function (Mn, Templates) {
  var MainLayout = Mn.LayoutView.extend({
    template: Templates.IRB['main.layout'],
    events: {
      "click .skip-link": function click_SkipLink() {
        $("#irb-content").focus();
      },
      "keydown .skip-link": function keydown_SkipLink(event) {
        if (event.key === " ") {
          event.preventDefault();
          $("#irb-content").focus();
        }
      }
    },
    regions: {
      header: '.header',
      content: '#irb-content',
      overlay: 'div.overlay',
      dimmer: 'div.dimmerContainer'
    },
    attributes: {
      style: 'height: 100%; width: 100%; position: relative;'
    },
    initialize: function initialize() {
      var app = this.getOption('app');
      this.listenTo(app.channel, 'resize:menu', this.applyPadding);
    },
    applyPadding: function applyPadding(size) {
      var app = this.getOption('app');
      this.$el.css('padding-left', size.left);
      this.$el.css('padding-top', size.top);
    }
  });
  return MainLayout;
});

